import { ChatCircleText, PencilSimpleLine } from "@phosphor-icons/react";
import type { ChatMode } from "./ChatTestForm";

type Props = {
  mode: ChatMode;
  onModeChange: (mode: ChatMode) => void;
  chapterName?: string;
  disabled?: boolean;
};

export function ModeToggle({ mode, onModeChange, chapterName, disabled }: Props) {
  const editLabel = chapterName ? `Edit ${chapterName}` : "Edit";

  return (
    <div className="flex items-center px-3 py-1.5">
      <div className="flex gap-0.5 rounded-lg bg-innoveraZinc-50 p-0.5">
        <button
          type="button"
          onClick={() => onModeChange("ask")}
          disabled={disabled}
          className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium transition-all duration-200 disabled:opacity-50 ${
            mode === "ask"
              ? "bg-white text-innoveraZinc-900 shadow-sm"
              : "text-innoveraZinc-500 hover:text-innoveraZinc-700"
          }`}
        >
          <ChatCircleText className="h-3.5 w-3.5" />
          Ask project
        </button>
        <button
          type="button"
          onClick={() => onModeChange("edit")}
          disabled={disabled}
          title={editLabel}
          className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium transition-all duration-200 disabled:opacity-50 min-w-0 ${
            mode === "edit"
              ? "bg-white text-innoveraZinc-900 shadow-sm"
              : "text-innoveraZinc-500 hover:text-innoveraZinc-700"
          }`}
        >
          <PencilSimpleLine className="h-3.5 w-3.5 shrink-0" />
          <span className="truncate">{editLabel}</span>
        </button>
      </div>
    </div>
  );
}
